export default function () {
  const widgetName = 'cardWidgetQuickLinks';
  const widgetOpts = cardWidgetQuickLinksOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
    },
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;
      if (widgetCount == 0) {
        $(`#${widgetName}`).remove();
      } else {
        $(`#${widgetName}`).show();
        removeUnusedTags();
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['title'],
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}

// remove buttonwrap if empty
function removeUnusedTags() {
  $('#cardWidgetQuickLinks .card-widget-item').each(function () {
    let cardDescription = $(this).find('.card-widget-description');
    let buttonWrap = $(this).find('.buttonwrap');

    if (cardDescription.is(':empty')) {
      cardDescription.remove();
    }

    if (buttonWrap.is(':empty')) {
      buttonWrap.remove();
    }
  });
}
